import request from "../utils/request"

// 平台客服数据就在爬宠后端（/api/admin/shop/conversations），与后台管理系统共用管理员登录态，
// 不再需要单独登录“商城后端”。
export function ensureShopToken() {
  return Promise.resolve(localStorage.getItem("admin_token") || "")
}

export function fetchPlatformConversations() {
  return request.get("/admin/shop/conversations")
}

export function fetchPlatformMessages(conversationId) {
  return request.get(`/admin/shop/conversations/${encodeURIComponent(conversationId)}/messages`)
}

export function sendPlatformMessage(conversationId, content) {
  return request.post(`/admin/shop/conversations/${encodeURIComponent(conversationId)}/messages`, { content })
}

// 平台客服的实时推送：走爬宠后端的 /ws/chat，用管理员令牌鉴权。
export function shopSocketUrl() {
  const token = localStorage.getItem("admin_token")
  if (!token) return ""
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:"
  return `${protocol}//${window.location.host}/ws/chat?role=platform&token=${encodeURIComponent(token)}`
}
